export const money = (v, dp = 2) =>
  "$" + Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: dp, maximumFractionDigits: dp });

export const num = (v) => Number(v || 0).toLocaleString("en-US");

export const shortAddr = (a) => (a ? `${a.slice(0, 6)}...${a.slice(-4)}` : "-");

export const dateFmt = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};
